let Photos1950=[
  {
    "NameEN": "1950",
    "Image": "un7",
    "CaptionEN": "US President Dwight Eisenhower delivered the \"Atoms for Peace\" speech at the UNGA, 1953 [Getty images]",
    "CaptionAR": "الرئيس الأميركي دوايت إيزنهاور يلقي في جلسة الجمعية العامة عام 1953 خطاب \"استخدامات الذرة لأجل السلام\" (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un9",
    "CaptionEN": "A Soviet tank is captured in Budapest during the Hungarian Revolution, 1956 [Getty Images]",
    "CaptionAR": "دبابة سوفياتية بين المحتجين خلال أحداث ثورة المجر عام 1956 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un8",
    "CaptionEN": "A ship is sunk at the Suez Canal to block passage, 1956 [Getty Images]",
    "CaptionAR": "سفينة أغرقت بغرض عرقلة الحركة في قناة السويس عام 1956 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un10",
    "CaptionEN": "Newly appointed UN Secretary General Dag Hammarskjold, 1953 [Getty Images]",
    "CaptionAR": "الأمين العام للأمم المتحدة داغ هامرشولد المعين عام 1953 (غيتي)"
  }
]
export default Photos1950